import './assets/main.css'
import 'leaflet/dist/leaflet.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
// import 'element-plus/dist/index.css'
import './assets/element.scss'

import App from './App.vue'
import router from './router'
import dateDiff from './plugins/dateDiff.js'
import minusDate from './plugins/minusDate.js'
import toUnixInteger from './plugins/toUnixInteger.js'
import addDate from './plugins/addDate.js'
import toMillisecondsDate from './plugins/toMillisecondsDate.js'
import { createPersistedState } from 'pinia-plugin-persistedstate'
import formatDate from './plugins/formatDate'
import formateDate from './plugins/formateDate'
import currencyFormat from './plugins/currencyFormat'
import getTranslate from './plugins/getTranslate'
import currencyPrice from './plugins/currencyPrice'
import urlFormat from './plugins/urlFormat'
import VueEasyLightbox from 'vue-easy-lightbox'

import 'vue-easy-lightbox/dist/external-css/vue-easy-lightbox.css'
import getImage from './plugins/getImage'
import getUsername from './plugins/getUsername'
import getCategory from './plugins/getCategory'
import placeTypeString from './plugins/placeTypeString'
import convertCurrency from '@/components/currency/convertCurrency.vue'

const app = createApp(App)
const pinia = createPinia()

pinia.use(createPersistedState({
  key: id => `adm-kd-${id}`,
}))

app.use(pinia)
app.use(router)
app.use(ElementPlus)
app.use(dateDiff, {})
app.use(minusDate, {})
app.use(toUnixInteger, {})
app.use(toMillisecondsDate, {})
app.use(minusDate, {})
app.use(addDate, {})
app.use(formatDate)
app.use(formateDate)
app.use(currencyFormat)
app.use(currencyPrice)
app.use(getTranslate)
app.use(VueEasyLightbox)
app.use(getImage)
app.use(getUsername)
app.use(getCategory)
app.use(placeTypeString)
app.use(urlFormat)
app.component('ConvertCurrency', convertCurrency)

app.mount('#app')
